import { useGatewayImage } from '../hooks/useGatewayImage'

const SIZE = {
  xs: 'w-8 h-8',
  sm: 'w-9 h-9',
  md: 'w-10 h-10',
  lg: 'w-16 h-16',
  xl: 'w-24 h-24',
} as const

export type AccountAvatarSize = keyof typeof SIZE

interface AccountAvatarProps {
  avatarUrl?: string | null
  size?: AccountAvatarSize
  className?: string
}

export default function AccountAvatar({
  avatarUrl,
  size = 'sm',
  className = '',
}: AccountAvatarProps) {
  const { src, failed, onError, imgProps } = useGatewayImage(avatarUrl)

  const dim = SIZE[size]
  const showImage = Boolean(avatarUrl) && !failed && Boolean(src)
  const glow =
    size === 'xl'
      ? '0 0 24px rgba(67,160,71,0.35)'
      : '0 0 12px rgba(67,160,71,0.35)'

  if (showImage) {
    return (
      <img
        key={src}
        src={src!}
        alt=""
        className={`${dim} rounded-full object-cover flex-shrink-0 ${className}`}
        style={{ border: '1px solid rgba(255,255,255,0.1)' }}
        onError={onError}
        {...imgProps}
      />
    )
  }

  return (
    <img
      src="/logo.png"
      alt=""
      className={`${dim} rounded-full object-cover flex-shrink-0 ${className}`}
      style={{
        border: '1px solid rgba(255,255,255,0.08)',
        boxShadow: glow,
      }}
      draggable={false}
    />
  )
}
